import { render, staticRenderFns } from "./LawMatterCourtExpertList.vue?vue&type=template&id=463ead3a&"
import script from "./LawMatterCourtExpertList.vue?vue&type=script&lang=js&"
export * from "./LawMatterCourtExpertList.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterCourtExpertList.vue?vue&type=style&index=0&id=463ead3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports